
import React, { Component } from "react";
import { MDBRow, MDBCol } from 'mdbreact';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/themes/light.css';
import 'tippy.js/animations/shift-toward.css';
import 'tippy.js/animations/shift-toward-subtle.css';
import 'tippy.js/animations/shift-toward-extreme.css';
export class Card extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customStyles: {
        marginTop:'0px',
        marginBottom:'10%', 
        padding: '15px 15px 0', 
        fontWeight:500
      },
      genericStyle:{
        padding: '15px 15px 0'
      }
    };
  }
  render() {
    const { customStyles,genericStyle } = this.state;
    
    return (
      <div 
      className={"card" + (this.props.filter ? " card-filter" : "") + (this.props.plain ? " card-plain" : "")} style={{boxShadow:this.props.shadowbox ? this.props.shadowbox : ''}}>
        <div>
           {typeof this.props.condition === "object" ? 
           <MDBRow>
              <MDBCol md="6" className = "mb-3">
              <h5 style={{marginInlineStart:"1em"}}>{this.props.condition.props.children[0]}
                <a href='#!' className='font-weight-bold' style={{color:'#D54C2F'}}>
                  <strong> {this.props.condition.props.children[1].props.children[1]} </strong>
                </a>
              </h5>
              </MDBCol>
              </MDBRow> : ""}          
        </div>
        {this.props.filter !== true ? 
        <div>
        <MDBRow>
        <MDBCol md="5" className = "mb-5">
          <h4 style={this.props.id === 'chartHours' ? customStyles : genericStyle}>{this.props.title}
          {this.props.elements ?
                  <div style={{marginTop:'-20px'}}>
                    <Tippy offset={[60, 20]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                      <h5 style={{height:'34px', width:'15rem', fontSize:"13px"}}>Inventory will be loaded based on the selected locations only</h5>
                    </div>}>
                      {this.props.infoIcon}
                    </Tippy>
                  </div> : 
            <a href='#!' className='font-weight-bold' style={{color:'#D54C2F'}}>
            <strong> {this.props.title2}  </strong>
            </a>}
          </h4>
        </MDBCol>
        {this.props.id === 'chartHours' &&
        <>
        <MDBCol md="5" className = "mb-5">
        </MDBCol>
        <MDBCol md="2" className = "mb-2">
          <h4 className="header">{this.props.drop}
          </h4>
        </MDBCol>
        </>}
          <br></br>
       {this.props.hCenter == "Available Serial Number : " && 
        <MDBCol md="3" className = "mb-3">
        <h4 className={"text-center"} style={{marginTop:"24px", marginInline:"-3em"}}>{`${this.props.hCenter}`}
            <a href='#!' className='font-weight-bold' style={{color:'#D54C2F'}}>
            <strong> {this.props.iotQty}  </strong>
            </a>
          </h4>
          </MDBCol>
          }
          {this.props.condition && 
        <MDBRow>
          <MDBCol md="3" className = "mb-3">
          <h4 style={{marginTop:"-9px", marginInlineStart:"-67rem"}}>{this.props.condition}
          </h4>
          </MDBCol>
        </MDBRow>}
          </MDBRow>
          <MDBCol md="12" className="mb-12">
          <div style={{float: 'right'}}>{this.props.button}
          </div>
          </MDBCol>
          </div> : ""}
        <div 
          className={
            "content"  + 
            
            (this.props.ctAllIcons ? " all-icons" : "") +
            (this.props.ctTableFullWidth ? " table-full-width" : "") +
            (this.props.ctTableResponsive ? " table-responsive" : "") +
            (this.props.ctTableUpgrade ? " table-upgrade" : "")
          }
        >
          {this.props.content}

          <div className="footer" >
            {this.props.legend}
            {this.props.stats != null ? <hr /> : ""}
            <div className="stats">
              <i className={this.props.statsIcon} /> {this.props.stats}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Card;